import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Logo from "../../assets/images/logo-login.png";
import { AuthContext } from "../../context/AuthContext";
import Auth from "../../service/Auth";
import Loading from "../Loading/Loading";
import { toast } from 'react-toastify';
import { UserContext } from "../../context/UserContext";
import { Box, SmallText, } from "./FormLoginStyle";
import Translation from "../Translation/Translation";
import { useTranslation } from "react-i18next";
import Login from "../../service/Login";
import Companies from "../../service/Companies";
import secureLocalStorage from "react-secure-storage";
import { trackEventMatomo } from "../../helpers/matomo";
import { Button, IconButton, Stack, TextField, Typography } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import LoginIcon from '@mui/icons-material/Login';
import EmailIcon from '@mui/icons-material/Email';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import { Rings } from "react-loading-icons";


const loginService = new Login();
const companiesService = new Companies();

console.log(process.env.NODE_ENV);
console.log(process.env.REACT_APP_PROJECT_NAME);

const url = process.env.NODE_ENV === 'production' ?
  'http://admin.axyma.com.br/resetPassword' :
  'http://a0a4316a9a7304018b11eb236a19d5a9-606525459.us-west-2.elb.amazonaws.com/resetPassword';


function FormLogin() {
  const { saveLoginToken, setTicking, ticking } = useContext(AuthContext);
  const { saveUserData, openModal, popUp, setHierarchyLabel, setFirebaseToken } = useContext(UserContext);
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [inputType, setInputType] = useState("password");
  const [resetValue, setResetValue] = useState('');
  const [loadingReset, setLoadingReset] = useState<boolean>(false);
  const navigate = useNavigate();
  const { t } = useTranslation('translation');

  const onStorageUpdate = (e: any) => {
    const { key, newValue } = e;
    if (key === "user") {
      setUser(newValue);
    } if (key === 'password') {
      setPassword(newValue);
    }
  };


  const handleSubmit = async () => {
    setIsLoading(true);
    const loginData = await saveLoginToken({ email: user, senha: password });
    if (loginData) {
      setFirebaseToken(loginData.token);
      const auth = new Auth(loginData.uid, loginData.userName, loginData.empresa);
      const token = await auth.getToken();
      const hierarchyLabels = await companiesService.getHierarchyLabels({
        userToken: token,
        username: loginData.userName,
        userEmpresa: loginData.empresa,
        empresa: loginData.empresa
      });
      setHierarchyLabel(hierarchyLabels);
      const userData = await auth.confirmLoginAndGetData();
      if (userData) {
        saveUserData(userData);
        localStorage.setItem('userDataLocal', JSON.stringify(userData));
        window.localStorage.setItem('click', 'click');
        localStorage.removeItem("@secure.s.user");
        localStorage.removeItem("@secure.s.password");
        localStorage.removeItem("click");
        setTicking(true);
        navigate("/home");
      }
    }
    else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setUser(localStorage.getItem("user") || "");
    setPassword(localStorage.getItem("password") || "");
    window.addEventListener("storage", onStorageUpdate);
    window.addEventListener('storage', function (event) {
      if (event.key === 'click' && event.newValue !== event.oldValue) {
        window.location.reload();
      }
    });
    return () => {
      window.removeEventListener("storage", onStorageUpdate);
    };
  }, []);

  const now = new Date();

  useEffect(() => {
    ticking && setTicking(false);
  }, [ticking, setTicking]);

  const toggleEye = () => inputType === "password" ? setInputType("text") : setInputType("password");

  return (
    <Stack
      width="100%"
      height="100svh"
      direction="row"
      sx={{
        justifyContent: "center",
        alignItems: "center",
        background: 'linear-gradient(to right, #9a72c9, #612a79)',
      }}
    >
      <Box>
        <Stack
          direction="column"
          spacing={1}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            color: 'white'
          }}
          width='250px'>
          <Translation header={false} />
          <img width="150px" alt="Axyma" src={Logo} style={{ borderRadius: '5px', filter: 'contrast(150%)' }} />
          <Typography color="white" variant="body1" fontWeight={600}>{t('loginScreen.welcomelogin')}</Typography>
          <Typography color="white" variant="caption">{t('loginScreen.login')}</Typography>
          <form
            id='form'
            onSubmit={(e) => {
              trackEventMatomo('login', 'click', 'form', 'login');
              e.preventDefault();
              handleSubmit();
            }}
            autoComplete="off">
            <Stack
              direction="column"
              spacing={1.5}
              sx={{
                justifyContent: "center",
                alignItems: "stretch",
              }}
            >

              <TextField
                disabled={isLoading}
                variant="filled"
                InputProps={{ style: { backgroundColor: 'white' } }}
                size="small"
                fullWidth
                onClick={() => trackEventMatomo('login', 'click', 'input', 'edita valor')}
                required
                label={t('loginScreen.username')}
                value={user}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setUser(e.target.value);
                  secureLocalStorage.setItem("user", e.target.value);
                }}
              />
              <Stack
                direction="row"
                spacing={0.5}
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >

                <TextField
                  disabled={isLoading}
                  variant="filled"
                  InputProps={{ style: { backgroundColor: 'white' } }}
                  size="small"
                  onClick={() => trackEventMatomo('login', 'click', 'input', 'edita valor')}
                  required
                  fullWidth
                  type={inputType}
                  label={t('loginScreen.password')}
                  value={password}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setPassword(e.target.value);
                    secureLocalStorage.setItem("password", e.target.value);
                  }}
                />
                <IconButton sx={{ color: 'white' }} onClick={toggleEye}>
                  {inputType === "password" ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )
                  }
                </IconButton>
              </Stack>
              <Button
                disabled={isLoading || !user || !password}
                endIcon={!isLoading ? <LoginIcon /> : <></>}
                variant='contained'
                type='submit'
                className='button is-white'
              >
                {isLoading
                  ? <Rings speed={.5} stroke="#612a79" />
                  : t('loginScreen.loginbtn')}
              </Button>
            </Stack>
          </form>
          <Button
            sx={{ color: 'white', fontSize: '9px !important' }}
            size="small"
            variant="text"
            className="button is-small"
            onClick={() => {
              trackEventMatomo('login', 'click', 'button', 'abre modal');
              openModal();
            }}
          >
            {t('loginScreen.forgot')}
          </Button>
          <div className={`modal ${popUp ? "modal is-active" : "modal"} `}>
            <div className="modal-background" />
            <div className="modal-card">
              <header className="modal-card-head">
                <Stack
                  direction="column"
                  spacing={1}
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: '100%', justifyContent: 'flex-end', display: 'flex' }}>
                    <Button
                      startIcon={<ArrowCircleLeftIcon />}
                      size="small"
                      className="button is-small"
                      onClick={() => {
                        openModal();
                        trackEventMatomo('modal reset de senha', 'click', 'button', 'fecha modal');
                      }}
                    >
                      {t('return')}
                    </Button>
                  </div>
                  <Typography variant="h5" fontWeight={600} color='textDisabled'>
                    {t('loginScreen.forgotModal')}
                  </Typography>
                  <Typography fontSize={12} fontWeight={600} color='textDisabled'>
                    {t('loginScreen.textModal')}
                  </Typography>
                </Stack>

              </header>
              <form onSubmit={async (e) => {
                trackEventMatomo('modal reset de senha', 'click', 'button', 'reset de senha');
                e.preventDefault();
                setLoadingReset(true);
                toast.warning('Enviando e-mail com reset de senha.');
                await loginService.sendEmailReset({ login: resetValue, lastPasswordRequired: false, url: url as string });
                toast.success(`${t('toast.emailSentSuccessfully')}`);
                setLoadingReset(false);
                openModal();
              }}>
                <div className="modal-card-body">
                  <TextField
                    fullWidth
                    required
                    type="text"
                    onClick={() => trackEventMatomo('modal reset de senha', 'click', 'input', 'edita valor')}
                    label={t('loginScreen.inputModal')}
                    value={resetValue}
                    onChange={(e: any) => setResetValue(e.target.value)}
                  />
                </div>
                <footer className="modal-card-foot">
                  <div className="buttons">
                    <Button
                      type="submit"
                      endIcon={<EmailIcon />}
                      disabled={loadingReset}
                      className="button is-success is-small"
                    >
                      {t('loginScreen.sendModal')}
                    </Button>
                  </div>
                </footer>
              </form>
            </div>
          </div>
          <SmallText>Axyma @ {now.getFullYear()}</SmallText>
        </Stack>
      </Box>
    </ Stack>
  );
}
export default FormLogin;